<template>
  <div class="bigscreen-sales">
    <div class="bigscreen-sales__header">
      <!-- 头部 -->
      <SalesHeader />
    </div>
    <div class="bigscreen-sales__body">
      <!-- 统计部分 -->
      <Statistics />
      <!-- 下半部分 左 中 右结构 -->
      <div class="vocational">
        <!-- 业务结单统计 -->
        <div class="vocational-left">
          <ReceivingOrders class="con-box" />
        </div>
        <div class="vocational-center m-l-16">
          <!-- 近13个月业务数量统计 -->
          <Quantity class="con-box top" />
          <!-- 今日出货计划表 -->
          <ShippingSchedule class="con-box bottom" />
        </div>
        <div class="vocational-right m-l-16">
          <!-- 部门未完成工时统计 -->
          <ManHour class="con-box top" />
          <!-- 品质异常统计 -->
          <Unusual class="con-box bottom" />
        </div>
      </div>
    </div>
    <div class="bigscreen-sales__bottom" >
    </div>
  </div>
</template>

<script>
import SalesHeader from './components/SalesHeader.vue'
import Statistics from './components/Statistics.vue'
import ReceivingOrders from './components/ReceivingOrders.vue'
import Quantity from './components/Quantity.vue'
import ShippingSchedule from './components/ShippingSchedule.vue'
import ManHour from './components/ManHour.vue'
import Unusual from './components/Unusual.vue'
export default {
  name: 'index',
  data () {
    return {}
  },
  components: {
    SalesHeader,
    Statistics,
    ReceivingOrders,
    Quantity,
    ShippingSchedule,
    ManHour,
    Unusual
  },
  watch: {},
  mounted () {
    document.documentElement.webkitRequestFullScreen()
  },
  methods: {}
}
</script>

<style scoped lang="less">
  .bigscreen-sales {
    width: 100%;
    height: 100vh;
    padding-top: 4px;
    box-sizing: border-box;
    background: #010916;
    display: flex;
    flex-direction: column;

    &__header {
      width: 100%;
      height: 74px;
      background: linear-gradient(270deg,
          #060c16 0%,
          rgba(9, 28, 45, 0.9) 50.06%,
          #11182d 101.04%);
    }

    &__body {
      margin-top: 4px;
      flex: 1;
      min-height: 0;
      padding: 0 24px;
      display: flex;
      flex-direction: column;

      .vocational {
        flex: 1;
        min-height: 0;
        margin-top: 10px;
        display: flex;

        .con-box {
          background: rgba(10, 36, 62, 0.6);
          border-radius: 8px;
          padding: 16px;
          box-sizing: border-box;
        }

        .vocational-left {
          width: 425px;
          height: 100%;
        }

        .vocational-center,
        .vocational-right {
          display: flex;
          flex-direction: column;
          height: 100%;

          .top {
            flex: 1;
            margin-bottom: 16px;
          }

          .bottom {
            min-height: 0;
            height: 56%;
          }
        }

        .vocational-center {
          width: 991px;
        }

        .vocational-right {
          width: 424px;
        }
      }
    }

    &__bottom {
      width: 100%;
      height: 60px;
      background-image: url('../../assets/images/bigscreenSales/bottom.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/bigscreenSales/companychart.vue